/*
 * Purpose: Deep links + remediation paths — P6 clean URLs only
 * Last modified: 2026-06-28 | Agent
 * Completeness: 100
 */
import { APP_ROUTES } from '@/lib/appRoutes';
import { gapActionLabel as classifyGapActionLabel, gapRemediationHref } from '@/lib/gapRemediation';

export const REMEDIATION = {
  setup: APP_ROUTES.connectSetup,
  setupVault: APP_ROUTES.connectSetup,
  setupSecrets: APP_ROUTES.connectSecrets,
  setupGoogle: APP_ROUTES.connectSetup,
  compose: APP_ROUTES.compose,
  dashboard: APP_ROUTES.dashboard,
  flows: APP_ROUTES.flows,
  flowTemplates: APP_ROUTES.flowTemplates,
  mission: APP_ROUTES.missionMap,
  connect: APP_ROUTES.connect,
  connectMcp: APP_ROUTES.connectMcp,
  builderSecrets: APP_ROUTES.connectSecrets,
  missionLogs: APP_ROUTES.missionInsightsLogs,
} as const;

/** @deprecated Use gapRemediationHref from gapRemediation.ts */
export function gapSetupHref(gap: string): string {
  return gapRemediationHref(gap) ?? REMEDIATION.setup;
}

export function gapActionLabel(gap: string): string {
  return classifyGapActionLabel(gap);
}
